import Header from '../components/Header';
import Books3 from '../components/Books3';
// import HIW from '../components/HIWs';
// import NFTsGrid from '../components/Nfts';
import Footer from '../components/Footer';


export default function Bookpage2() {
  return (
    <div className=" text-white bg-darkBlue ">
      <Header page={"create"} />
      <Books3 />
      <Footer />

    </div>
  );
}
